import { clarify } from '@/domain/services/VueDataProvider';
import { getGlobal } from '@/lib/utils';

const clarifiedData = () => {
	const obfuscatedData = getGlobal('obfuscatedData');
	if (!obfuscatedData) return [];

	return clarify(obfuscatedData);
};

const globals = {
	get: (key) => clarifiedData()[key],
};

const useGlobals = (keys) => keys.map((key) => globals.get[key]);
const useGlobal = (key) => globals.get(key);

export { globals, useGlobals, useGlobal };
